// extracted by mini-css-extract-plugin
export var SubscribeForm = "index-module--SubscribeForm--MQJay";
export var block = "index-module--block---vrkp";
export var flex = "index-module--flex--ziRUJ";